import { render, staticRenderFns } from "./setComboOut.vue?vue&type=template&id=219c11fa&scoped=true&"
import script from "./setComboOut.vue?vue&type=script&lang=js&"
export * from "./setComboOut.vue?vue&type=script&lang=js&"
import style0 from "./setComboOut.vue?vue&type=style&index=0&id=219c11fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219c11fa",
  null
  
)

component.options.__file = "setComboOut.vue"
export default component.exports